import { effect } from "@preact/signals";
import { Component, h } from "preact";
/** @import { ComponentType } from "preact"; */

import { loggedIn } from "~/lib/session.js";

import { navigate } from "~/util/router.js";

/** Only render while logged out; redirect to the dashboard when logged in. */
export const ensureLoggedOut = createGuard(false, "/");

/** Only render while logged in; redirect to login when logged out. */
export const ensureLoggedIn = createGuard(true, "/login/");

/**
 * Gate a page on the session and redirect whenever it no longer matches. Cache wrappers so
 * rebuilding a route table preserves component identity.
 *
 * @param {boolean} requiresLogin
 * @param {string} redirect
 */
function createGuard(requiresLogin, redirect) {
	/** @type {WeakMap<ComponentType<any>, ComponentType<any>>} */
	const cache = new WeakMap();

	/**
	 * @template [P =any]
	 * @param {ComponentType<P>} component
	 * @returns {ComponentType<P>}
	 */
	return function ensure(component) {
		const cached = cache.get(component);
		if (cached) return cached;

		class Guard extends Component {
			#dispose = effect(() => {
				if (loggedIn.value !== requiresLogin) navigate(redirect, { replace: true });
			});

			/** @override */
			componentWillUnmount() {
				this.#dispose();
			}

			render() {
				if (loggedIn.value !== requiresLogin) return null;
				return h(component, this.props);
			}
		}

		cache.set(component, Guard);
		return Guard;
	};
}
